import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { AddMaterial, CheckDraftMaterialForPublishedCourse, MaterialDownloadAuditLog, UpdateMaterial } from '../components/materials/materials';
import { MaterialList, MaterialQueryFilters } from '../components/materials/material-list';

@Injectable({
  providedIn: 'root'
})
export class MaterialsService {
  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  getMaterialQueryParams(filter: MaterialQueryFilters): HttpParams {
    return new HttpParams({ fromObject: filter })
  }

  getMaterialTypes():any{
    let matTypes :any[]=[];
    matTypes.push({id:1,type:'Audio/Slides'})
    matTypes.push({id:2,type:'E-book'})
    matTypes.push({id:3,type:'Worksheet'})
    matTypes.push({id:4,type:'Video'})
    return matTypes
  }
  getMaterialLanguages():Observable<any[]>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get<any[]>(this.apiUrl+'language/getApplicationLanguages',{headers:headers})
  }
  getMaterialStatus(condition: string, materialid?: string): Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams().set('condition', condition);
    if (materialid) {
      params = params.set('materialid', materialid);
    }
    return this.http.get<any[]>(this.apiUrl + 'materials/getMaterialStatus', { headers, params });
  }

  createMaterial(material:AddMaterial):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    });
    const payload = {
      materialName: material.materialName,
      materialType: material.materialType,
      language: material.language,
      tags: material.tags,
      status: material.status,
      materialFileId: material.materialFileId,
    };
    return this.http.post<any>(this.apiUrl+'materials/createMaterial', payload, {headers:headers})
  }

  getAllMaterials(queryFilter: MaterialQueryFilters): Observable<any> {
    if (queryFilter.Tag == null)
      queryFilter.Tag = 0;

    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    const params = this.getMaterialQueryParams(queryFilter);
    return this.http.get<MaterialList[]>(this.apiUrl+"materials/getAllMaterials/",{headers:headers,params:params,observe:'response'})
  }

  getReplacementMaterials():Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get<MaterialList[]>(this.apiUrl+"materials/getReplacementMaterials",{headers:headers})
  }


  getMaterialDetailsById(id:string):Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
     let params = new HttpParams()
     params = params.append('id',id.toString());
    return this.http.get<any>(this.apiUrl+"materials/getMaterialById",{headers:headers,params:params})
  }

  getMaterialDetailsforUpdate(id:string):Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
     let params = new HttpParams()
     params = params.append('id',id.toString());
    return this.http.get<UpdateMaterial>(this.apiUrl+"materials/getMaterialDetailsForUpdate",{headers:headers,params:params})
  }

  updateMaterial(material:UpdateMaterial):Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    const payload: UpdateMaterial = { ...material };
    if (!payload.replacementMaterialId) {
      delete (payload as { replacementMaterialId?: string }).replacementMaterialId;
    }
    return this.http.post<any>(this.apiUrl+'materials/updateMaterial', payload, {headers:headers})
  }

  deleteMaterial(id:string):Observable<any>{
    const token = this._authservice.getAuthToken();
    const header = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams()
    params = params.append('id',id.toString());
    return this.http.post<any>(this.apiUrl+'materials/deleteMaterial',null,{headers:header,params:params})
  }

  getMaterialAuditLogs(id:string):Observable<any>{
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('id',id.toString());
    return this.http.get<any>(this.apiUrl+"materials/getMaterialAuditLogs",{headers, params});
  }

  auditMaterialDownload(model: MaterialDownloadAuditLog): Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post<any>(this.apiUrl+'materials/auditMaterialDownload',model,{headers:headers})
  }

  checkDraftMaterialForPublishedCourse(model:CheckDraftMaterialForPublishedCourse): Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post<any>(this.apiUrl+'materials/checkDraftMaterialForPublishedCourse',model,{headers:headers})
  }
}
